import {
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { useSelector } from 'react-redux';
import { closeIcon } from '../../../../assets/images/index';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';

interface Role {
  roleID: string | number;
  roleName?: string;
}

interface ParamDrawer {
  paramCloseDrawer: () => void;
  paramSubmit: (data: any) => void;
  formEditData: any;
  editPage?: boolean;
}

const ControllerParameterForm: React.FC<ParamDrawer> = ({
  paramCloseDrawer,
  paramSubmit,
  formEditData,
  editPage,
}) => {
  const { allRole } = useSelector((state: any) => state.role);
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    variableName: '',
    behaviour: '',
    customerAccess: false,
    comment: '',
  });
  const [parmNameError, setParmNameError] = useState('');
  const [parmTypeError, setParmTypeError] = useState('');
  const [parmVariableError, setParmVariableError] = useState('');
  // const [parmBehaviourError, setParmBehaviourError] = useState('');
  const [parmTagsError, setParmTagsError] = useState('');
  const [tagName, setTagName] = React.useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [isActive, setIsActive] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { fetchGetAllRoleList } = RoleHook();

  useEffect(() => {
    setFormData(formEditData);
    setSelectedTags(
      formEditData?.accessPermissions ? formEditData?.accessPermissions : [],
    );
    if (formEditData?.behaviour === 'READ') {
      setIsChecked(true);
    }
  }, [formEditData]);

  useEffect(() => {
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
  }, []);

  const handleChangeTagName = (event: any) => {
    const {
      target: { value },
    } = event;
    setTagName(typeof value === 'string' ? value.split(',') : value);
    setParmTagsError('');
    setIsActive(true);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = allRole?.filter((role: { roleName: string }) =>
      role.roleName?.toLowerCase().includes(query),
    );
    setFilteredRoles(filtered);
  };
  useEffect(() => {
    setFilteredRoles(allRole);
  }, [allRole]);

  const handleParamChange = (e: any) => {
    const { name, value, checked } = e.target;
    name === 'customerAccess'
      ? setFormData((prevState) => ({
          ...prevState,
          [name]: checked,
        }))
      : setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
  };

  const handleClick = () => {
    setIsChecked((prevState) => !prevState); // Toggle the state
  };

  const handleActiveChange = () => {
    setIsActive(true);
  };

  const paramValidation = () => {
    let valid = true;
    if (formData?.name?.trim().length <= 0) {
      setParmNameError('Name is required');
      valid = false;
    }
    if (formData?.type?.trim().length <= 0) {
      setParmTypeError('Type is required');
      valid = false;
    }
    if (formData?.variableName?.trim().length <= 0) {
      setParmVariableError('variable Name is required');
      valid = false;
    }
    if (selectedTags?.length <= 0) {
      setParmTagsError('Tags  is required');
      valid = false;
    }
    return valid;
  };
  const submitParam = (e: any) => {
    e.preventDefault();
    if (paramValidation()) {
      setIsActive(false);
      const parameters = {
        name: formData?.name,
        type: formData?.type,
        variableName: formData?.variableName?.replace(/\s/g, ''),
        behaviour: isChecked ? 'READ' : 'WRITE',
        accessPermissions: selectedTags,
        customerAccess: formData?.customerAccess,
        comment: formData?.comment,
      };
      paramSubmit(parameters);
    }
  };

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedTags((prevselectedTags) => {
      if (prevselectedTags.includes(roleName)) {
        const updatedRoles = prevselectedTags.filter(
          (roles) => roles !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevselectedTags, roleName];
        return updatedRoles;
      }
    });
  };
  
  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: Role) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };
  return (
    <form onSubmit={submitParam}>
      <div className="controller_form_container">
        <div className="create_controller-nodata_drawer">
          <div className="create_controller-nodata_drawer_heading_content">
            <h2 className="create_controller-nodata_drawer_heading">
              {editPage ? 'Edit Parameter' : 'Add Parameter'}
            </h2>
          </div>

          <div className="create_controller-nodata_drawer_form_content">
            <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                Name
              </InputLabel>
              <TextField
                disabled={editPage ? true : false}
                className="create_controller-nodata_drawer_form_field_input"
                variant="outlined"
                fullWidth
                type="text"
                id="name"
                name="name"
                value={formData?.name}
                onChange={(e: any) => {
                  handleParamChange(e);
                  setParmNameError('');
                  handleActiveChange();
                }}
                error={parmNameError ? true : false}
              />
              {parmNameError && (
                <Typography variant="body2" className="text-danger">
                  {parmNameError}
                </Typography>
              )}
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel
                id="select-label"
                className="create_controller-nodata_drawer_form_field_lable"
              >
                Type
              </InputLabel>
              <Select
                disabled={editPage ? true : false}
                labelId="select-label"
                className="create_controller-nodata_drawer_form_field_input"
                id="type"
                name="type"
                value={formData?.type}
                onChange={(e: any) => {
                  handleParamChange(e);
                  setParmTypeError('');
                  handleActiveChange();
                }}
                IconComponent={ExpandMore}
                error={parmTypeError ? true : false}
              >
                <MenuItem value="float">Float</MenuItem>
              </Select>
              {parmTypeError && (
                <Typography variant="body2" className="text-danger">
                  {parmTypeError}
                </Typography>
              )}
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                Variable Name
              </InputLabel>
              <TextField
                disabled={editPage ? true : false}
                className="create_controller-nodata_drawer_form_field_input"
                variant="outlined"
                fullWidth
                id="variableName"
                name="variableName"
                value={formData?.variableName}
                onChange={(e: any) => {
                  handleParamChange(e);
                  setParmVariableError('');
                  handleActiveChange();
                }}
                error={parmVariableError ? true : false}
              />
              {parmVariableError && (
                <Typography variant="body2" className="text-danger">
                  {parmVariableError}
                </Typography>
              )}
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_field_radio">
              <InputLabel
                component="legend"
                className="create_controller-nodata_drawer_form_field_radiolable"
              >
                Behaviour
              </InputLabel>

              <FormControlLabel
                className="create_controller-nodata_drawer_form_field_radioinput create_controller-nodata_drawer_form_checkbox"
                control={
                  <Checkbox
                    id="behaviour"
                    name="behaviour"
                    disabled={editPage ? true : false}
                    checked={isChecked}
                    onClick={handleClick}
                    onChange={(e: any) => {
                      // handleParamChange(e);
                      handleActiveChange();
                    }}
                  />
                }
                label="Read Only"
              />
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel
                className="create_controller-nodata_drawer_form_field_lable"
                id="demo-multiple-checkbox-label"
              >
                Accessible To
              </InputLabel>

              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                className="create_controller-nodata_drawer_form_field_input"
                multiple
                displayEmpty
                value={tagName}
                onChange={handleChangeTagName}
                error={parmTagsError ? true : false}
                renderValue={() => (
                  <div className="selecter_dropdown_placeholder">
                    Add or Remove Roles
                  </div>
                )}
                IconComponent={ExpandMore}
              >
                <div className="selectoption_content">
                  <div className="selectoption_search_content">
                    <TextField
                      className="selectoption_searchbar search-input"
                      variant="outlined"
                      placeholder="Search user"
                      fullWidth
                      InputProps={{
                        startAdornment: <SearchIcon className="search_icon" />,
                      }}
                      onChange={handleUserSearch}
                    />
                  </div>
                  <div className="selectoption_list_content">
                    {filteredRoles.map((role, index) => (
                      <div key={index} className="selectoption_list">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedTags.includes(
                                String(role.roleID),
                              )}
                              onChange={() => {
                                handleRoleSelection(String(role.roleID));
                              }}
                            />
                          }
                          label={role.roleName}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </Select>
              <div className="select_Role_Chip-data">
                {selectedTags.map((value) => (
                  <Chip
                    key={value}
                    label={findrolename(value)}
                    deleteIcon={
                      <img src={closeIcon} alt="Delete Icon" width={13} />
                    }
                    onDelete={() =>
                      setSelectedTags(
                        selectedTags.filter((val) => val !== value),
                      )
                    }
                    className="create_controller-nodata_drawer_form_selectchip"
                  />
                ))}
              </div>
              {parmTagsError && (
                <Typography variant="body2" className="text-danger">
                  {parmTagsError}
                </Typography>
              )}
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    id="customerAccess"
                    name="customerAccess"
                    checked={formData?.customerAccess}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      handleParamChange(e);
                      handleActiveChange();
                    }}
                  />
                }
                label="Customer Access"
              />
            </FormGroup>

            <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel
                htmlFor="comment"
                className="create_controller-nodata_drawer_form_field_lable"
              >
                Comment
              </InputLabel>
              <TextField
                // disabled={editPage ? true : false}
                className="create_controller-nodata_drawer_form_field_textarea"
                variant="outlined"
                multiline
                rows={5}
                maxRows={10}
                id="comment"
                name="comment"
                value={formData?.comment}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  handleParamChange(e);
                  handleActiveChange();
                }}
              />
            </FormGroup>
          </div>
        </div>
        <div className="create_controller-nodata_drawer_button_content">
          <div className="create_controller-nodata_drawer_button">
            <Button
              variant="text"
              className="cencel_button"
              onClick={paramCloseDrawer}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className={
                isActive ? 'save_button' : 'save_button disabled_button'
              }
              type="submit"
              disabled={!isActive}
            >
              {editPage ? 'Save Changes' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

const MemoizedComponent = React.memo(ControllerParameterForm);
export default MemoizedComponent;
